import { useQuery } from "@tanstack/react-query";
import { Star, Quote } from "lucide-react";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";

export default function Testimonials() {
  useSeo({ title: "Testimonials", description: "What clients say about working with Buddy Solution." });
  const { data: items = [] } = useQuery({ queryKey: ["testimonials"], queryFn: async () => (await api.get("/testimonials")).data });

  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Testimonials" title="Trusted by clients worldwide"
        subtitle="Placeholder testimonials are shown until verified client quotes are added, we never fabricate reviews." /></Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map((t, i) => (
          <Reveal key={t.id || i} delay={i * 0.05}>
            <div className="flex h-full flex-col bs-card p-7">
              <Quote className="h-8 w-8 text-primary/30" />
              <p className="mt-3 flex-1 leading-relaxed">{t.quote}</p>
              <div className="mt-5 flex items-center gap-1 text-chart-4">
                {Array.from({ length: t.rating || 5 }).map((_, j) => <Star key={j} className="h-4 w-4 fill-current" />)}
              </div>
              <div className="mt-3">
                <p className="font-bold">{t.name}</p>
                <p className="text-sm text-muted-foreground">{t.role}{t.company ? `, ${t.company}` : ""}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
